function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PictureComponent from "components/core/picture/picture-component";
import { BRAND_BLACK_TEXT_COLOR, CRM_DARKER_TINT_02_COLOR_NAME, WHITE_COLOR_NAME, WORK_OS_IRIS_COLOR_NAME, DEV_DARKER_TINT_02_COLOR_NAME } from "styles/color-consts";
import { CRM_PRODUCT_ID, DEV_PRODUCT_ID, WORK_MANAGEMENT_PRODUCT_ID } from "constants/products";
import { isDarkTheme } from "segments/segments-service";
import { useMemo } from "react";
import colors from "styles/colors";
import classnames from "classnames";
import ProductCardTitle from "./product-card-title/product-card-title";
import ProductCardContent from "./product-card-content/product-card-content";
import ProductCardFeatures from "./product-card-features/product-card-features";
import DefaultProps from "./default-props";
import { StyledProductCard } from "./product-card.scss";
const PRODUCT_TO_COLORS = {
    [WORK_MANAGEMENT_PRODUCT_ID]: WORK_OS_IRIS_COLOR_NAME,
    [CRM_PRODUCT_ID]: CRM_DARKER_TINT_02_COLOR_NAME,
    [DEV_PRODUCT_ID]: DEV_DARKER_TINT_02_COLOR_NAME
};
const ProductCard = ({ productType = WORK_MANAGEMENT_PRODUCT_ID, cardTitle, cardBackgroundColor, cardTitleConfig, cardContent, cardAsset, isCondensed, showUseCasesVertically })=>{
    const _ref = cardContent || {}, { features, cardPaddingTop, cardPaddingBottom } = _ref, restOfCardContent = _object_without_properties(_ref, [
        "features",
        "cardPaddingTop",
        "cardPaddingBottom"
    ]);
    const cardStyle = useMemo(()=>({
            backgroundColor: colors[cardBackgroundColor],
            color: isDarkTheme(cardBackgroundColor) ? colors[WHITE_COLOR_NAME] : colors[BRAND_BLACK_TEXT_COLOR],
            paddingTop: cardPaddingTop,
            paddingBottom: cardPaddingBottom
        }), [
        cardBackgroundColor
    ]);
    return /*#__PURE__*/ _jsxs(StyledProductCard, {
        className: classnames("product-card-component", {
            "condensed-card": isCondensed
        }),
        style: cardStyle,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "card-top",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "product-details",
                        children: [
                            /*#__PURE__*/ _jsx(ProductCardTitle, _object_spread_props(_object_spread({}, cardTitle), {
                                titleConfig: cardTitleConfig,
                                color: PRODUCT_TO_COLORS[productType]
                            })),
                            /*#__PURE__*/ _jsx(ProductCardContent, _object_spread({
                                productType: productType,
                                productColor: PRODUCT_TO_COLORS[productType],
                                showUseCasesVertically: showUseCasesVertically
                            }, restOfCardContent))
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "product-image",
                        children: /*#__PURE__*/ _jsx(PictureComponent, {
                            src: cardAsset
                        })
                    })
                ]
            }),
            (features === null || features === void 0 ? void 0 : features.length) > 0 && /*#__PURE__*/ _jsx(ProductCardFeatures, {
                features: features
            })
        ]
    });
};
export default ProductCard;
ProductCard.defaultProps = DefaultProps;
